/// <amd-module name="SuiteCommerce.Testimonials.Main"/>
define("SuiteCommerce.Testimonials.Main", ["require", "exports", "SuiteCommerce.Testimonials.TestimonialsCCT", "SuiteCommerce.Testimonials.Common.InstrumentationHelper"], function (require, exports, TestimonialsCCT, InstrumentationHelper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(container.getComponent('Environment'));
            TestimonialsCCT.mountToApp(container);
        }
    };
});
